import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import {
  ILoadBalancerChannel,
  ILoadBalancerChannelPatch,
} from '../../../../view/settings/api-automation-settings/load-balancer-channels/load-balancer-channels.model';

export enum ActionTypes {
  LOAD_BALANCER_CHANNELS_DATA_LOADING = '[LOAD_BALANCER_CHANNELS] LOAD_BALANCER_CHANNELS DATA LOADING',
  LOAD_BALANCER_CHANNELS_DATA_LOADED = '[LOAD_BALANCER_CHANNELS] LOAD_BALANCER_CHANNELS DATA LOADED',
  GET_LOAD_BALANCER_CHANNEL = '[LOAD_BALANCER_CHANNELS] GET_LOAD_BALANCER_CHANNEL LOADING',
  GET_LOAD_BALANCER_CHANNEL_COMPLETED = '[LOAD_BALANCER_CHANNELS] GET_LOAD_BALANCER_CHANNEL COMPLETED',
  EDIT_LOAD_BALANCER_CHANNEL = '[LOAD_BALANCER_CHANNELS] EDIT_LOAD_BALANCER_CHANNEL',
  EDIT_LOAD_BALANCER_CHANNEL_COMPLETED = '[LOAD_BALANCER_CHANNELS] EDIT_LOAD_BALANCER_CHANNEL COMPLETED',
  FETCH_ERROR = '[LOAD_BALANCER_CHANNELS] FETCH ERROR',
}

export class LoadBalancerChannelsLoading implements Action {
  readonly type = ActionTypes.LOAD_BALANCER_CHANNELS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class LoadBalancerChannelsLoaded implements Action {
  readonly type = ActionTypes.LOAD_BALANCER_CHANNELS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<ILoadBalancerChannel>) {}
}

export class GetLoadBalancerChannel implements Action {
  readonly type = ActionTypes.GET_LOAD_BALANCER_CHANNEL;

  constructor(public recordId: number) {}
}

export class GetLoadBalancerChannelCompleted implements Action {
  readonly type = ActionTypes.GET_LOAD_BALANCER_CHANNEL_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ILoadBalancerChannel>) {}
}
export class EditLoadBalancerChannel implements Action {
  readonly type = ActionTypes.EDIT_LOAD_BALANCER_CHANNEL;

  constructor(
    public recordId: number,
    public record: ILoadBalancerChannelPatch,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditLoadBalancerChannelCompleted implements Action {
  readonly type = ActionTypes.EDIT_LOAD_BALANCER_CHANNEL_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ILoadBalancerChannel>) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type LoadBalancerChannelActions =
  | LoadBalancerChannelsLoading
  | LoadBalancerChannelsLoaded
  | GetLoadBalancerChannel
  | GetLoadBalancerChannelCompleted
  | EditLoadBalancerChannel
  | EditLoadBalancerChannelCompleted
  | FetchError;
